import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignInComponent } from './auth/sign-in/sign-in.component';
import { AdminHomeComponent } from './components/admin/admin-home/admin-home.component';
import { AdminPushComponent } from './components/admin/admin-push/admin-push.component';
import { AdminRantingComponent } from './components/admin/admin-ranting/admin-ranting.component';
import { AdminComponent } from './components/admin/admin.component';
import { ConfirmMailComponent } from './components/confirm-mail/confirm-mail.component';
import { ErrorComponent } from './components/error/error.component';
import { RateComponent } from './components/ratings/rate/rate.component';
import { RatingsComponent } from './components/ratings/ratings.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { AuthGuard } from './shared/guard/auth.guard';
import { UnauthGuard } from './shared/guard/unauth.guard';

const routes: Routes = [
  { path: 'signin', canActivate: [UnauthGuard], component: SignInComponent },
  {
    path: 'admin',
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },

      {
        path: 'home',
        canActivate: [AuthGuard],
        component: AdminHomeComponent,
      },
      {
        path: 'push',
        canActivate: [AuthGuard],
        component: AdminPushComponent,
      },
      {
        path: 'rating',
        canActivate: [AuthGuard],
        component: AdminRantingComponent,
      },
      {
        path: 'ratings/:id',
        canActivate: [AuthGuard],
        component: RateComponent,
      },
      {
        path: 'ratings',
        canActivate: [AuthGuard],
        component: RatingsComponent,
      },
    ],
  },
  { path: 'change-password', component: ResetPasswordComponent },
  { path: 'confirm-mail', component: ConfirmMailComponent },
  { path: 'error', component: ErrorComponent },
  { path: '', redirectTo: 'admin', pathMatch: 'full' },
  // { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
